import { useAtom } from 'jotai'
import type { NodeToRenderProps } from '@src/components/custom-nodes/types';
import { selectedNodePropsAtom } from '@src/atoms/popover'
import { addOpenedInfoModal, setCurrentModalId } from '@src/atoms';

export const useNodeSelection = () => {
  const [, setSelectedNodeProps] = useAtom(selectedNodePropsAtom);

  const nodeClickHandler = (_event: React.MouseEvent, node: NodeToRenderProps) => {
    setSelectedNodeProps(node);
    addOpenedInfoModal(node.id);
    setCurrentModalId(node.id);
  }
  const paneClickHandler = () => {
    setSelectedNodeProps(null);
  }

  return {
    onNodeClick: nodeClickHandler,
    onPaneClick: paneClickHandler,
  }
};
